module.exports = __webpack_public_path__ + "static/img/5.5845e1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/5.png
// module id = f5DM
// module chunks = 0